import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { getCookie } from "../../../../util/cookie/cookies";
import { useAppSelector } from "../../../../store/storeHooks";

const Footer = () => {
    const {t} = useTranslation()
    const lang = getCookie('BINEXLANG')
    const location = useLocation()
    const navigate = useNavigate()
    const menuInfo : any = useAppSelector(state=>state.menuInfo.menuInfo)
    const handleTransPage = (page:string) => {
        if(location.pathname !== page){navigate(page)}
    }
    const userInfo : any = useAppSelector(state => state.loginUser.userInfo)
    return(
        <>
        <footer>
            <div>
                <div>
                    <div className="logoBox">
                        <span onClick={() => navigate('/')}></span>
                        <span onClick={() => navigate('/')}></span>
                    </div>
                    <div className="listBox">
                        <div>
                            <span className="orange" onClick={() => navigate('/products?ch=&rs=&ft=')}>Dash Cams</span>
                            <ul>
                                <li>
                                    <span className="disabled">By Channel</span>
                                    <ul>
                                        {menuInfo?.channel?.map((channel: any, index: number) => (
                                          <>
                                              {index !== 2 && (
                                                <li key={index} onClick={() => navigate(`/products?ch=${channel?.menuId}&rs=&ft=`)}>
                                                    {channel?.menuName}
                                                </li>
                                              )}
                                          </>

                                        ))}
                                    </ul>
                                </li>
                                <li>
                                    <span className="disabled">By Resolution</span>
                                    <ul>
                                        {menuInfo?.resolution?.map((resolution: any, index: number) => (
                                          <li key={index} onClick={() => navigate(`/products?ch=&rs=${resolution?.menuId}&ft=`)}>
                                              {resolution?.menuName}
                                          </li>
                                        ))}
                                    </ul>
                                </li>
                                <li>
                                    <span className="disabled">By Features</span>
                                    <ul>
                                        {menuInfo?.features?.map((features: any, index: number) => (
                                          <li key={index} onClick={() => navigate(`/products?ch=&rs=&ft=${features?.menuId}`)}>
                                              {features?.menuName}
                                          </li>
                                        ))}
                                    </ul>
                                </li>

                                <li>
                                    <ul>
                                        <li>
                                            <span className="disabled">Accessories</span>
                                        </li>
                                        <li onClick={() => handleTransPage('/products/39?product=FinePower-250')}>
                                            BATTERY PACK
                                        </li>
                                        <li onClick={() => handleTransPage('/products/102?product=HardwireKit')}>
                                            Hardwire Kit
                                        </li>
                                    </ul>
                                </li>


                                <li className="white" onClick={() => handleTransPage('/productComparison')}>Product Comparision</li>
                                <li className="orange" onClick={() => handleTransPage('/blog')}>Blog</li>
                                <li className="orange" onClick={() => handleTransPage('/fineVu')}>About us</li>
                            </ul>
                        </div>

                        <div>
                            <span className="orange">Golf rangefinder</span>
                            <ul>
                                <li>
                                    <ul>
                                        <li onClick={() => handleTransPage('/products/100?product=UPL2000')}>
                                            UPL2000
                                        </li>
                                        <li className="" onClick={() => handleTransPage('/products/101?product=UPL9')}>
                                            UPL9
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                            <span className="orange">Creator Support</span>
                            <ul>
                                <li>
                                    <span className="disabled">Brand Assets</span>
                                    <ul style={{marginBottom: '50px'}}>
                                        <li onClick={() => handleTransPage('/creator-support/brand-assets?tab=product')}>
                                            Product Images
                                        </li>
                                        <li onClick={() => handleTransPage('/creator-support/brand-assets?tab=video')}>
                                            Video Footage
                                        </li>
                                        <li onClick={() => handleTransPage('/creator-support/brand-assets?tab=brand-identity')}>
                                            Brand Identity
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <span className="orange">Contact</span>
                            <ul>
                                <li>
                                    <span className="disabled">Customer Support</span>
                                    <ul>
                                        <li onClick={() => handleTransPage('/support/warrentyService/prRegistration')}>Product Registration</li>
                                        <li onClick={() => handleTransPage('/support/warrentyService/policy')}>Warranty Policy</li>
                                        <li onClick={() => handleTransPage(userInfo?.userId === 'null' || userInfo?.userId === null || userInfo?.userId === '' ? `/support/warrentyService/myDashcam` : `/support/warrentyService/myDashcam/${userInfo?.userId}`)}>My Page</li>
                                        <li onClick={() => handleTransPage('/support/warrentyService/trouble-shooting')}>Troubleshooting</li>
                                        <li onClick={() => handleTransPage('/location')}>Where to Buy</li>
                                    </ul>
                                </li>
                                <li>
                                    <span className="disabled">&nbsp;</span>
                                    <ul>
                                        <li onClick={() => handleTransPage('/support/download/dashcam')}>FineVu Dashcam</li>
                                        <li onClick={() => handleTransPage('/support/download/wifiapp')}>FineVu Wi-Fi APP</li>
                                        <li onClick={() => handleTransPage('/support/download/pcplayer')}>FineVu PC Player</li>
                                        <li onClick={() => handleTransPage('/contact/customerSupport/customerContact')}>Customer Contact</li>
                                    </ul>
                                </li>
                                <li>
                                <span className="disabled">Dealer Support</span>
                                    <ul>
                                        <li onClick={() => handleTransPage('/contact/dealer-support/dealer-contact')}>Dealer Contact</li>
                                    </ul>
                                </li>

                                <li className="white" onClick={() => handleTransPage('/sitemap')}>Sitemap</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- 진한 검정색 박스 Fin --> */}
            <div>
                <div>
                    <div>
                        <p>
                            <span>ADD</span>
                            7th Floor, Fine Venture Bldg., 41, Seongnam-daero 925 beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, 13496 Rep. of KOREA
                        </p>
                        <div>
                            <p>
                                <span>TEL</span>
                                (USA Toll Free) +1 646 895 6154 / (Canada Toll Free) +1 437 887 2499 / (Korea Only) +82 31 788 8800<br/>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Customer Support Hours: Monday–Friday, 9:00 AM–5:00 PM EST (UTC-5)
                            </p>
                            <p>
                                <span>FAX</span>
                                +82-31-788-8760
                            </p>
                            <p>
                                <span>E-MAIL</span>
                                support@finedigital.com
                            </p>
                        </div>
                    </div>

                    <div>
                        <div>
                            <p>Copyright ⓒ 2023-2025 FINEDIGITAL Inc., ALL RIGHTS RESERVED.</p>
                            <button onClick={() => navigate(`/privacy-policy`)}>Privacy Policy</button>
                            <button onClick={() => navigate(`/location-information-policy`)}>Location Information Policy</button>
                            {/* <button onClick={()=>navigate(`/privacy-policy-smartvu`)}>Privacy Policy SmartVu</button> */}

                        </div>
                        <ul>
                            <li className="facebook"><a href="https://www.facebook.com/FineVuDASHCAM" target="_blank"></a></li>
                            {/* <li className="twitter_x"></li> */}
                            <li className="youtube"><a href="https://www.youtube.com/channel/UCcjdOYjx1kDfcYbgVz9JuCQ" target="_blank"></a></li>
                            <li className="instagram"><a href="https://www.instagram.com/finevu_global" target="_blank"></a></li>
                            <li className="linkedin"><a href="https://www.linkedin.com/company/finevu/about/" target="_blank"></a></li>
                        </ul>
                    </div>
                </div>
            </div>
            {/* <!-- 연한 검정색 박스 Fin --> */}
        </footer>
        </>
    )
}
export default Footer;
